var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xkztck"},[_c('Header',{attrs:{"title":"选课状态查看","type":"0","route":"/homeIndex"}}),_vm._v(" "),_c('div',{staticClass:"xkztck_main"},[(_vm.list.length == 0)?_c('NOdata',{attrs:{"title":"暂无选课状态查看数据~"}}):_vm._l((_vm.list),function(item,index){return _c('mode-list',{key:index,attrs:{"item":item}})})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21ebb4b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newPages/teacher/xkztck/index.vue
// module id = null
// module chunks = 